import React, { Component } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

const CUSTOMER_TYPES = [
    { value: 'individual', label: 'บุคคล', icon: 'fas fa-user', color: '#17a2b8' },
    { value: 'organization', label: 'องค์กร', icon: 'fas fa-university', color: '#6610f2' },
    { value: 'company', label: 'บริษัท', icon: 'fas fa-building', color: '#dc3545' }
];

const CONTACT_TYPES = [
    { value: 'phone', label: 'เบอร์โทร', icon: 'fas fa-phone', color: '#28a745', placeholder: '08x-xxx-xxxx' },
    { value: 'line', label: 'LINE', icon: 'fab fa-line', color: '#06c755', placeholder: '@lineid หรือ line://...' },
    { value: 'email', label: 'อีเมล', icon: 'fas fa-envelope', color: '#dc3545', placeholder: 'email@example.com' },
    { value: 'fax', label: 'Fax', icon: 'fas fa-fax', color: '#6c757d', placeholder: '02-xxx-xxxx' },
    { value: 'address', label: 'ที่อยู่', icon: 'fas fa-map-marker-alt', color: '#ff9800', placeholder: 'ที่อยู่เต็ม' },
    { value: 'facebook', label: 'Facebook', icon: 'fab fa-facebook', color: '#1877f2', placeholder: 'FB URL หรือ username' },
    { value: 'other', label: 'อื่นๆ', icon: 'fas fa-comment-alt', color: '#888', placeholder: '' }
];

function contactMeta(type) {
    return CONTACT_TYPES.find(t => t.value === type) || CONTACT_TYPES[CONTACT_TYPES.length - 1];
}

export function CustomerEdit(props) {
    var nav = useNavigate();
    var params = useParams();
    return <CustomerEditInner {...props} navigate={nav} id={params.id} />;
}

class CustomerEditInner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                id: 0, customerType: 'individual',
                firstName: '', lastName: '', nickname: '',
                idCard: '', passport: '', passportExpiry: '', dob: '', gender: '',
                note: '', isActive: 1,
                contacts: [{ type: 'phone', value: '', note: '', sort: 0 }]
            },
            loading: !!props.id,
            saving: false,
            error: ''
        };
    }

    componentDidMount() {
        if (this.props.id) {
            fetch('api/customer/' + this.props.id)
                .then(r => r.ok ? r.json() : null)
                .then(data => {
                    if (data) {
                        var contacts = data.contacts && data.contacts.length > 0 ? data.contacts : [{ type: 'phone', value: '', note: '', sort: 0 }];
                        this.setState({ form: { ...this.state.form, ...data, contacts }, loading: false });
                    } else this.setState({ loading: false, error: 'ไม่พบข้อมูล' });
                })
                .catch(() => this.setState({ loading: false, error: 'เกิดข้อผิดพลาด' }));
        }
    }

    upd = (field, val) => this.setState({ form: { ...this.state.form, [field]: val }, error: '' });

    updContact = (i, field, val) => {
        var contacts = [...this.state.form.contacts];
        contacts[i] = { ...contacts[i], [field]: val };
        this.upd('contacts', contacts);
    }

    addContact = (type) => {
        var contacts = [...this.state.form.contacts, { type: type || 'phone', value: '', note: '', sort: this.state.form.contacts.length }];
        this.upd('contacts', contacts);
    }

    removeContact = (i) => {
        var contacts = this.state.form.contacts.filter((_, idx) => idx !== i);
        if (contacts.length === 0) contacts.push({ type: 'phone', value: '', note: '', sort: 0 });
        this.upd('contacts', contacts);
    }

    moveContact = (i, dir) => {
        var contacts = [...this.state.form.contacts];
        var j = i + dir;
        if (j < 0 || j >= contacts.length) return;
        [contacts[i], contacts[j]] = [contacts[j], contacts[i]];
        this.upd('contacts', contacts);
    }

    save = async (close) => {
        var { form } = this.state;
        if (!form.firstName.trim() && !form.lastName.trim()) {
            this.setState({ error: 'กรุณากรอกชื่อ หรือ นามสกุล' });
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }
        this.setState({ saving: true, error: '' });
        try {
            var r = await fetch('api/customer', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-User-Username': localStorage.getItem('username') || '',
                    'X-User-Display-Name': localStorage.getItem('displayName') || ''
                },
                body: JSON.stringify(form)
            });
            if (!r.ok) {
                var e = await r.json().catch(() => ({}));
                throw new Error(e.message || 'save failed');
            }
            var res = await r.json();
            if (close) {
                this.props.navigate('/console/customer');
            } else {
                if (!form.id) this.props.navigate('/console/customer/edit/' + res.id, { replace: true });
                this.setState({ form: { ...form, id: res.id }, saving: false });
                alert('บันทึกสำเร็จ');
            }
        } catch (e) {
            this.setState({ error: 'บันทึกไม่สำเร็จ: ' + e.message, saving: false });
        }
    }

    renderSectionHeader(icon, title) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingBottom: 14, marginBottom: 20, borderBottom: '1px solid #f0f0f0' }}>
                <span style={{ width: 36, height: 36, borderRadius: 8, background: 'linear-gradient(135deg,#dc3545,#9d1a26)', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className={icon}></i>
                </span>
                <div style={{ fontSize: 16, fontWeight: 800, color: '#333' }}>{title}</div>
            </div>
        );
    }

    render() {
        var { form, loading, saving, error } = this.state;
        var isEdit = form.id > 0;
        var isIndividual = form.customerType === 'individual';

        if (loading) return <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>;

        return (
            <div style={{ padding: '28px 20px 40px', maxWidth: 1200, margin: '0 auto' }}>
                <div className="d-flex justify-content-between align-items-center mb-4" style={{ flexWrap: 'wrap', gap: 10 }}>
                    <Link to="/console/customer" className="btn btn-outline-secondary btn-sm"><i className="fas fa-arrow-left"></i> กลับ</Link>
                    <div className="d-flex" style={{ gap: 8 }}>
                        <button className="btn btn-outline-danger" onClick={() => this.save(false)} disabled={saving}>
                            <i className="fas fa-save"></i> บันทึก
                        </button>
                        <button className="btn btn-danger" onClick={() => this.save(true)} disabled={saving}>
                            <i className="fas fa-save"></i> บันทึกและปิด
                        </button>
                    </div>
                </div>

                {error && (
                    <div className="alert alert-danger mb-3">
                        <i className="fas fa-exclamation-circle"></i> {error}
                    </div>
                )}

                {isEdit && (form.createdBy || form.updatedBy) && (
                    <div style={{ background: '#f8f9fa', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 12, color: '#666', display: 'flex', flexWrap: 'wrap', gap: 18 }}>
                        {form.createdBy && (
                            <div><i className="fas fa-user-plus" style={{ color: '#28a745', marginRight: 4 }}></i> สร้างโดย <strong>{form.createdByName || form.createdBy}</strong>{form.createdAt && <span style={{ color: '#999', marginLeft: 6 }}>· {new Date(form.createdAt).toLocaleString('th-TH')}</span>}</div>
                        )}
                        {form.updatedBy && (
                            <div><i className="fas fa-user-edit" style={{ color: '#17a2b8', marginRight: 4 }}></i> แก้ไขล่าสุดโดย <strong>{form.updatedByName || form.updatedBy}</strong>{form.updatedAt && <span style={{ color: '#999', marginLeft: 6 }}>· {new Date(form.updatedAt).toLocaleString('th-TH')}</span>}</div>
                        )}
                    </div>
                )}

                {/* Customer type selector */}
                <div style={{ background: '#fff', borderRadius: 12, padding: '18px 20px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 20 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#555', marginBottom: 10 }}>ประเภทลูกค้า</div>
                    <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                        {CUSTOMER_TYPES.map(t => (
                            <button key={t.value} type="button"
                                className={'btn ' + (form.customerType === t.value ? 'btn-danger' : 'btn-outline-secondary')}
                                onClick={() => this.upd('customerType', t.value)}>
                                <i className={t.icon}></i> {t.label}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="row g-3">
                    {/* Left column: Personal + Documents + Note */}
                    <div className="col-lg-7">
                        <div style={{ background: '#fff', borderRadius: 12, padding: '24px 28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 20 }}>
                            {this.renderSectionHeader('fas fa-user', isIndividual ? 'ข้อมูลส่วนตัว' : 'ข้อมูลทั่วไป')}
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label style={{ fontSize: 13, fontWeight: 700 }}>{isIndividual ? 'ชื่อ *' : 'ชื่อ (บริษัท/องค์กร) *'}</label>
                                    <input className="form-control" value={form.firstName} onChange={e => this.upd('firstName', e.target.value)} autoFocus />
                                </div>
                                {isIndividual && (
                                    <div className="col-md-6">
                                        <label style={{ fontSize: 13, fontWeight: 700 }}>นามสกุล</label>
                                        <input className="form-control" value={form.lastName} onChange={e => this.upd('lastName', e.target.value)} />
                                    </div>
                                )}
                                {!isIndividual && (
                                    <div className="col-md-6">
                                        <label style={{ fontSize: 13, fontWeight: 700 }}>ชื่อย่อ / สาขา</label>
                                        <input className="form-control" value={form.lastName} onChange={e => this.upd('lastName', e.target.value)} />
                                    </div>
                                )}
                                <div className="col-md-6">
                                    <label style={{ fontSize: 13, fontWeight: 700 }}>{isIndividual ? 'ชื่อเล่น' : 'ชื่อที่ใช้เรียก'}</label>
                                    <input className="form-control" value={form.nickname} onChange={e => this.upd('nickname', e.target.value)} />
                                </div>
                                {isIndividual && (
                                    <>
                                        <div className="col-md-3">
                                            <label style={{ fontSize: 13, fontWeight: 700, display: 'block', marginBottom: 6 }}>วันเกิด</label>
                                            <input type="date" className="form-control" value={form.dob || ''} onChange={e => this.upd('dob', e.target.value)} />
                                        </div>
                                        <div className="col-md-3">
                                            <label style={{ fontSize: 13, fontWeight: 700, display: 'block', marginBottom: 6 }}>เพศ</label>
                                            <select className="form-control" value={form.gender || ''} onChange={e => this.upd('gender', e.target.value)} style={{ height: 38 }}>
                                                <option value="">-</option>
                                                <option value="male">ชาย</option>
                                                <option value="female">หญิง</option>
                                                <option value="other">อื่นๆ</option>
                                            </select>
                                        </div>
                                    </>
                                )}
                                <div className="col-md-6">
                                    <label style={{ fontSize: 13, fontWeight: 700 }}>สถานะ</label>
                                    <div className="btn-group d-block">
                                        <button type="button" className={'btn btn-sm ' + (form.isActive ? 'btn-success' : 'btn-outline-success')} onClick={() => this.upd('isActive', 1)}><i className="fas fa-check-circle"></i> Active</button>
                                        <button type="button" className={'btn btn-sm ' + (!form.isActive ? 'btn-secondary' : 'btn-outline-secondary')} onClick={() => this.upd('isActive', 0)}><i className="fas fa-pause-circle"></i> Inactive</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ background: '#fff', borderRadius: 12, padding: '24px 28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 20 }}>
                            {this.renderSectionHeader('fas fa-id-card', isIndividual ? 'เอกสาร' : 'เอกสารบริษัท')}
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label style={{ fontSize: 13, fontWeight: 700 }}>{isIndividual ? 'เลขบัตรประชาชน' : 'เลขประจำตัวผู้เสียภาษี'}</label>
                                    <input className="form-control" style={{ fontFamily: 'monospace' }} value={form.idCard} onChange={e => this.upd('idCard', e.target.value)} />
                                </div>
                                {isIndividual && (
                                    <>
                                        <div className="col-md-3">
                                            <label style={{ fontSize: 13, fontWeight: 700 }}>Passport</label>
                                            <input className="form-control" style={{ fontFamily: 'monospace' }} value={form.passport} onChange={e => this.upd('passport', e.target.value)} />
                                        </div>
                                        <div className="col-md-3">
                                            <label style={{ fontSize: 13, fontWeight: 700 }}>หมดอายุ</label>
                                            <input type="date" className="form-control" value={form.passportExpiry || ''} onChange={e => this.upd('passportExpiry', e.target.value)} />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        <div style={{ background: '#fff', borderRadius: 12, padding: '24px 28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }}>
                            {this.renderSectionHeader('fas fa-sticky-note', 'หมายเหตุ')}
                            <textarea className="form-control" rows="5" placeholder="ข้อมูลเพิ่มเติม เช่น ข้อจำกัดอาหาร / โรคประจำตัว / ข้อมูลสำคัญ"
                                value={form.note} onChange={e => this.upd('note', e.target.value)}></textarea>
                        </div>
                    </div>

                    {/* Right column: Contacts */}
                    <div className="col-lg-5">
                        <div style={{ background: '#fff', borderRadius: 12, padding: '24px 28px 28px', boxShadow: '0 2px 12px rgba(0,0,0,0.06)', position: 'sticky', top: 20 }}>
                            {this.renderSectionHeader('fas fa-phone-alt', 'ช่องทางการติดต่อ')}

                            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                                {form.contacts.map((c, i) => {
                                    var m = contactMeta(c.type);
                                    var isAddress = c.type === 'address';
                                    return (
                                        <div key={i} style={{ border: '1px solid #eee', borderRadius: 10, padding: 12, background: '#fafbfc' }}>
                                            <div className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
                                                <select className="form-control form-control-sm" style={{ maxWidth: 140, borderColor: m.color }}
                                                    value={c.type} onChange={e => this.updContact(i, 'type', e.target.value)}>
                                                    {CONTACT_TYPES.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
                                                </select>
                                                <span style={{ width: 28, height: 28, borderRadius: '50%', background: m.color, color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, flexShrink: 0 }}>
                                                    <i className={m.icon}></i>
                                                </span>
                                                <div className="d-flex ms-auto" style={{ gap: 4 }}>
                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="เลื่อนขึ้น" onClick={() => this.moveContact(i, -1)} disabled={i === 0}>
                                                        <i className="fas fa-chevron-up"></i>
                                                    </button>
                                                    <button type="button" className="btn btn-sm btn-outline-secondary" title="เลื่อนลง" onClick={() => this.moveContact(i, 1)} disabled={i === form.contacts.length - 1}>
                                                        <i className="fas fa-chevron-down"></i>
                                                    </button>
                                                    <button type="button" className="btn btn-sm btn-outline-danger" title="ลบ" onClick={() => this.removeContact(i)}>
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            {isAddress ? (
                                                <textarea className="form-control form-control-sm mb-2" rows="2" placeholder={m.placeholder}
                                                    value={c.value} onChange={e => this.updContact(i, 'value', e.target.value)}></textarea>
                                            ) : (
                                                <input className="form-control form-control-sm mb-2" placeholder={m.placeholder}
                                                    value={c.value} onChange={e => this.updContact(i, 'value', e.target.value)} />
                                            )}
                                            <input className="form-control form-control-sm" placeholder="Note — เช่น ชื่อผู้ติดต่อ / บ้าน / ออฟฟิศ / มือถือ"
                                                value={c.note} onChange={e => this.updContact(i, 'note', e.target.value)} style={{ fontSize: 12, background: '#fff' }} />
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="d-flex flex-wrap mt-3" style={{ gap: 6 }}>
                                <span style={{ fontSize: 12, color: '#888', alignSelf: 'center' }}>เพิ่ม:</span>
                                {CONTACT_TYPES.slice(0, 5).map(t => (
                                    <button key={t.value} type="button" className="btn btn-sm btn-outline-secondary"
                                        onClick={() => this.addContact(t.value)}>
                                        <i className={t.icon} style={{ color: t.color }}></i> {t.label}
                                    </button>
                                ))}
                                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => this.addContact('other')}>
                                    <i className="fas fa-plus"></i> อื่นๆ
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-end mt-4" style={{ gap: 10 }}>
                    <Link to="/console/customer" className="btn btn-outline-secondary">ยกเลิก</Link>
                    <button className="btn btn-outline-danger" onClick={() => this.save(false)} disabled={saving}><i className="fas fa-save"></i> บันทึก</button>
                    <button className="btn btn-danger" onClick={() => this.save(true)} disabled={saving}><i className="fas fa-save"></i> บันทึกและปิด</button>
                </div>
            </div>
        );
    }
}
